import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { API } from 'aws-amplify';
import { from, Observable } from 'rxjs';
import { DEFAULT_GET_LIMIT } from '../shared/constants/operationals';

export const UNPAID_API_NAME: string = 'unpaid';
export const UNPAID_API_ENDPOINT: string = environment.API_BASE_PATH + '/unpaid';

@Injectable({
  providedIn: 'root',
})
export class UnpaidService {
  listUnpaid(list_params?: ListUnpaidParams): Observable<any> {
    const api_name: string = UNPAID_API_NAME;
    const path: string = '';

    let query_string_params: any = {
      cursor: list_params?.cursor || null,
      limit: list_params?.limit || DEFAULT_GET_LIMIT,
    };
    if (list_params?.order_id) query_string_params['order_id'] = list_params.order_id;
    if (list_params?.step_id) query_string_params['step_id'] = list_params.step_id;
    if (list_params?.created_from) query_string_params['created_from'] = list_params.created_from;
    if (list_params?.created_to) query_string_params['created_to'] = list_params.created_to;
    if (list_params?.due_date_from) query_string_params['due_date_from'] = list_params.due_date_from;
    if (list_params?.due_date_to) query_string_params['due_date_to'] = list_params.due_date_to;
    if (list_params?.status) query_string_params['status'] = list_params.status;
    if (list_params?.qinetic_id) query_string_params['qinetic_id'] = list_params.qinetic_id;
    if (list_params?.unpaid_days) query_string_params['unpaid_days'] = list_params.unpaid_days;
    if (list_params?.unsolved) query_string_params['unsolved'] = list_params.unsolved;
    if (list_params?.company_name) query_string_params['company_name'] = list_params.company_name;
    if (list_params?.store_name) query_string_params['store_name'] = list_params.store_name;
    if (list_params?.buyer_name) query_string_params['buyer_name'] = list_params.buyer_name;

    const init = { response: true, queryStringParameters: query_string_params };
    return from(API.get(api_name, path, init));
  }

  listByOrder(order_id: string): Observable<any> {
    const api_name: string = UNPAID_API_NAME;
    const path: string = `/order/${order_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }

  listByCompany(company_id: string): Observable<any> {
    const api_name: string = UNPAID_API_NAME;
    const path: string = `/company/${company_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }

  readSummary(): Observable<any> {
    const api_name: string = UNPAID_API_NAME;
    const path: string = '/summary';
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }

  setNote(unpaid: Unpaid): Observable<any> {
    const api_name: string = UNPAID_API_NAME;
    const path: string = '/set-note';
    const init = { response: true, body: { unpaid } };
    return from(API.put(api_name, path, init));
  }
}

export interface ListUnpaidParams {
  order_id?: string;
  step_id?: string;
  created_from?: number;
  created_to?: number;
  due_date_from?: number;
  due_date_to?: number;
  status?: UnpaidStatus;
  qinetic_id?: string;
  unpaid_days?: string;
  unsolved?: string;
  company_name?: string;
  store_name?: string;
  buyer_name?: string;

  cursor?: string | null;
  limit?: number;
}

export interface Unpaid {
  unpaid: boolean;
  created_at: number;
  days_unpaid?: number;
  attempt_counter?: number;
  recovered_at?: number;

  step_id?: string;
  order_id?: string;
  store_id?: string;
  amount?: number;

  qinetic_position_id?: string;
  position_id?: string;
  position_error?: any;

  due_date?: number;
  order_currency?: string;
  step_index?: number;

  note?: string;

  buyer_firstname?: string;
  buyer_lastname?: string;
  status?: UnpaidStatus;
}

export interface UnpaidSummary {
  total: number;
  to_recover: number;
  unpaid_0_5: number;
  unpaid_5_10: number;
  unpaid_10_15: number;
  unpaid_15_20: number;
  unpaid_20_25: number;
  unpaid_25_30: number;
}

export enum UnpaidStatus {
  pending = 'pending',
  canceled = 'canceled',
  recovered = 'recovered',
  expired = 'expired',
}

export enum Unsolved {
  yes = 'yes',
  no = 'no',
}
